import React from 'react';
import './NameSection.css';
import Typical from 'react-typical';
import hero from '../../../images/hero.jpg';

const NameSection = () => {
    return (
        <section className="home container text-white pt-2">
            <div className="row"  >
                <div  className="col-md-6 pt-4" style={{overflow: 'hidden'}} data-aos="fade-right" data-aos-duration="1000">
                    <div className="hero-text">
                        <span className="title">HELLO, I'M &nbsp;
                            <Typical
                                steps={[
                                    'A WEB DEVELOPER', 2500,
                                    'A PROGRAMMER', 2500,
                                    'A WEB DESIGNER', 2500,
                                ]}
                                loop={Infinity}
                                wrapper="span"
                            />

                        </span><br />
                        <span className="name">Shahinur Alam Bhuiyan</span><br />
                        <span className="quote">"A man who's brain loads with codes."</span> <br /><br />
                        <span className="email">
                            <i className="fa fa-envelope"></i>
                            <a href="mailto:shahinur.alam.bhuiyan01@gmail.com"> &nbsp;shahinur.alam.bhuiyan01@gmail.com</a>
                        </span><br />
                        <span className="phone">
                            <i className="fa fa-phone"></i> &nbsp;+88 01837-639712</span>

                        <div className="social-icon d-flex">
                            <a href='https://www.facebook.com/shahin19sep/' target='_blank'><i className="fa fa-facebook"></i></a>
                            <a href='https://twitter.com/ShahinurAlamBh1' target='_blank'><i className="fa fa-twitter"></i></a>
                            <a href='https://www.linkedin.com/in/shahinur-alam-bhuiyan-178161211/' target='_blank'><i className="fa fa-linkedin"></i></a>
                            <a href='https://github.com/ShahinurAlamBhuiyan' target='_blank'><i className="fa fa-github"></i></a>
                        </div>
                    </div>
                </div>

                <div style={{overflow: 'hidden'}} className="col-md-6" data-aos="fade-left" data-aos-duration="1000">
                    <div className="hero-img">
                        <div className="img-border">
                            <img src={hero} className="img-fluid" alt="" />
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default NameSection;